import React from 'react';
import { useMediaQueryContext } from '@fourthwall/components';
import { UpgradeSubscriptionButton } from '@modules/Dashboard/modules/Subscriptions';
import * as S from './UpgradeSubscriptionBanner.styled';
export const UpgradeSubscriptionBanner = ({ children, layout = 'horizontal', source, buttonLabel, onClick, }) => {
    const media = useMediaQueryContext();
    return (React.createElement(S.Container, { "$layout": layout },
        React.createElement(S.ContentContainer, null, children),
        React.createElement(UpgradeSubscriptionButton, { label: buttonLabel, source: source, fullWidth: !media.tablet || layout === 'vertical', onClick: onClick })));
};
